import enTranslation from './en/translation.json'
import svTranslation from './sv/translation.json'

export default {
  en: { translation: enTranslation },
  sv: { translation: svTranslation },
}
